const principleChartFilters = () => {
  const filters = [
    { index: 1, text: "Observations Trend" },
    { index: 2, text: "Observations by Topic" },
    { index: 3, text: "Findings and Best Practices" },
  ];

  if (
    window.location.origin.includes("sandbox") ||
    window.location.origin.includes("localhost")
  ) {
    filters.push({ index: 4, text: "ML Visualizations" });
  }

  return filters;
};

export default principleChartFilters;
